import React, {useEffect, useState} from 'react';

import {faChevronDown} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {useGlobalState} from 'hooks/useGlobalState';
import useOnClickOutside from 'hooks/useOnClickOutside';
import './AssignEditorDropdown.scss';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import {debounce} from 'lodash';
import {getUsersACS} from 'store/pageEditors/requestAC';

interface IProps {
  setSelectedUser: React.Dispatch<{name: string; id: null | number}>;
  pubEditorRef: React.MutableRefObject<HTMLInputElement | null>;
}

export const AssignEditorDropdown = ({pubEditorRef, setSelectedUser}: IProps) => {
  const dispatch = useSetGlobalState();

  const [isOpen, setIsOpen] = useState(false);
  const {pubEditors} = useGlobalState((state) => state.pubPage);

  const {usersList} = useGlobalState((state) => state.pageEditors);

  const [users, setUsers] = useState<{id: number; name: string}[]>([]);

  useEffect(() => {
    dispatch(getUsersACS());
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setUsers(usersList);
  }, [usersList]);

  const {containerRef} = useOnClickOutside<HTMLDivElement>(() => {
    setIsOpen(false);
  });

  const handleUserSelect = (userId: number) => {
    const foundUser = users.find((user) => user.id === userId);
    if (foundUser) setSelectedUser(foundUser);
  };

  const isSelected = (userId: number) => {
    const doesInclude = pubEditors.list.find((pubEditor) => +pubEditor.attributes.user.id === userId);
    return doesInclude ? true : false;
  };

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchedValue = e.target.value;

    let listOfUsers = [];

    if (searchedValue === '') {
      listOfUsers = usersList;
    } else {
      listOfUsers = usersList.filter((user) => user.name.toLowerCase().includes(searchedValue.toLowerCase()));
    }

    setUsers(listOfUsers);
  };

  return (
    <div className="assign-editor-dropdown" ref={containerRef}>
      <div
        className={`assign-editor-dropdown__search-wrapper ${
          isOpen ? 'assign-editor-dropdown__search-wrapper--open' : ''
        }`}
        role="button"
        tabIndex={0}
        onClick={() => setIsOpen((state) => !state)}
      >
        <input
          ref={pubEditorRef}
          type="text"
          placeholder="Select editor from the list"
          onChange={debounce(handleSearch, 500)}
        />
        <FontAwesomeIcon icon={faChevronDown} />
      </div>
      {isOpen && (
        <div className="assign-editor-dropdown__dropdown">
          {users.map((user) => {
            return (
              <button
                className={`assign-editor-dropdown__item ${
                  isSelected(user.id) ? 'assign-editor-dropdown__item--selected' : ''
                }`}
                key={user.id}
                title="page editor dropdown user"
                onClick={() => handleUserSelect(user.id)}
              >
                {user.name}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};
